module.exports = __webpack_public_path__ + "img/title.a8d6584d.svg";